import React from 'react';
import {
  Container,
  ExclamationTriangle,
  CheckIcon,
  Grimace,
  Button,
} from './style';

const AlertTemplate = ({ style, options, message, close }) => (
  <Container style={style}>
    {options.type === 'info' && <ExclamationTriangle />}
    {options.type === 'success' && <CheckIcon />}
    {options.type === 'error' && <Grimace />}
    {message}
    <Button onClick={close}>x</Button>
  </Container>
);

export default AlertTemplate;
